class CreateOrderError extends Error {
    constructor(err){
        super(err.status);
        this.name = 'CreateOrderError';
        Object.setPrototypeOf(this, CreateOrderError.prototype) // https://github.com/Microsoft/TypeScript/issues/15875
        ;
        this.status = err.status;
        this.label = err.label;
        this.cartHash = err.cartHash;
        this.cartId = err.cartId;
        this.type = err.type;
    }
}

export { CreateOrderError };
//# sourceMappingURL=create-order-error.js.map
